import React, { useState, useEffect } from "react";
// import { authServices } from "../../../../_services/Auth/AuthServices";
import roiIcon from "../../../../assets/images/roiIcon.png";
import clock from "../../../../assets/images/lead-icons/clock.png";

import styles from "./styles.module.css";
import { MdFileUpload } from "react-icons/md";
import { FileUploadService } from "../../../../_services/CommnService/FileUploadService/FileUploadService";
import { Col, Form } from "react-bootstrap";
import toastr from "toastr";
import greyTick from "../../../../assets/images/HomeView/grey_tick.png";
import uploadImage from "../../../../assets/images/upload-file-white.png";

const LoanOfferData = (props) => {
  // const [registrationPage, setRegistrationPage] = useState(1);
  const [avgtime, setAvgTime] = useState("");
  const [avgtimeValue, setAvgTimeValue] = useState("");

  //   const [gstVerified, setGstVerified] = useState(false);
  const [from, setFrom] = useState("");
  const [roiFromError, setRoiFromError] = useState("");
  const [roiToError, setRoiToError] = useState("");
  const [tatError, settatError] = useState("");
  const [imageError, setImageError] = useState("");

  const [to, setTo] = useState("");
  const [imageLink, setImageLink] = useState("");
  const [imageName, setImageName] = useState("");

  //   const [address, setAddress] = useState("");
  const avgTimeArray = [
    "less than 1 day",
    "1-3 days",
    "3-7 days",
    "more than 7 days",
  ];
  const avgTimeArrayState = {
    "less than 1 day": 0,
    "1-3 days": 1,
    "3-7 days": 2,
    "more than 7 days": 3,
  };

  const handleChange = (e, index) => {
    var fileList = e.target.files;
    if (fileList && fileList[0] && fileList[0].name) {
      let type_temp = fileList[0].name.split(".");
      let filesize = fileList[0].size;
      let type = type_temp[type_temp.length - 1];
      let extention = ["jpg", "JPG", "png", "PNG", "jpeg", "JPEG", "ico"];
      if (extention.includes(type) && filesize < 6000000) {
        var filecontainer = [];
        for (var i = 0; i < fileList.length; i++) {
          var file = fileList[i];
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            filecontainer.push(reader.result);
            if (filecontainer.length === fileList.length) {
              uploadImages(filecontainer, index, fileList);
            }
          };
          reader.onerror = function (error) {
            console.log("Error: ", error);
            toastr.error("please upload valid file");
          };
        }
      } else {
        toastr.warning("Please Upload Valid Image and Max Size Should be 6MB");
      }
    }
  };
  const uploadImages = async (files, index, fileList) => {
    // this.setState({
    //   isloading: true
    // })
    let imgarr = [];
    let uploadeds3link = [];
    for (var i = 0; i < files.length; i++) {
      var fileobj = {
        path: "arya/warehouseRequests/",
        file: files[i],
      };
      var apiresponse = await FileUploadService.fileUloadService(fileobj);
      if (apiresponse !== null && apiresponse.data.data.file_path) {
        var objimg = {
          src: apiresponse.data.data.file_path,
          thumbnail: apiresponse.data.data.file_path,
          thumbnailWidth: 100,
          thumbnailHeight: 100,
        };
        imgarr.push(objimg);
        uploadeds3link.push(apiresponse.data.data.file_path);
      }
    }
    setImageLink(uploadeds3link[0]);
    setImageName(fileList[0].name);
    setImageError("");
  };

  const onSubmit = () => {
    let flag = 0;
    if (!avgtime && avgtime !== 0) {
      settatError("Please select the value");
      flag = 1;
    }
    if (!from) {
      setRoiFromError("Please enter value");
      flag = 1;
    }
    if (!imageLink) {
      setImageError("Please upload Image");
      flag = 1;
    }
    if (!to) {
      setRoiToError("Please enter value");
      flag = 1;
    }
  
    if (from && to && +to < +from) {
      setRoiToError("Value should be greater than from ROI");
      flag = 1;
    }
    if (flag == 0) props.onSubmit(avgtime, from, to, imageLink);
  };
  return (
    <div>
      <div>
        In order to get loan leads from arya.ag, please fill out the following
        details
      </div>
      <div>
        <div className="mt-3 mb-1">
          <span className="text-danger">*</span> Upload bank logo
        </div>
        <Form.Group style={{ "padding-top": "1px" }}>
          <input
            type="file"
            onChange={(e) => handleChange(e)}
            // ref={(ref) => (this.fileInput = ref)}
            id={"custom-fileUpload"}
            style={{ display: "none" }}
          />
          <label
            htmlFor={"custom-fileUpload"}
            className="primaryP uploadFile-bx"
          >
            <img src={uploadImage} className={styles["imageCSSUnset"]} /> Upload
            Image
          </label>
        </Form.Group>
        {imageName && (
          <>
            {imageName}
            <img
              className="ml-2"
              src={greyTick}
              style={{ transform: "none" }}
            ></img>
            <br />
          </>
        )}
        {imageError && <div className="text-danger">{imageError}</div>}
        {/* <Form.Group as={Col} lg="12" style={{ "padding-top": "1px" }}>
                    {this.state.featured_image && <Image src={this.state.featured_image} style={{ width: '100px', height: 'auto' }} fluid alt="warehouse" />}
                  </Form.Group> */}
      </div>
      <div className="mt-3">
        <div className="">
          <span className="text-danger">*</span> Enter average turn around time
          to make loan offer
        </div>
        <div className="position-relative">
          <img
            src={clock}
            className={`position-absolute ${styles["clockCSS"]} ${styles["clockTop"]}`}
          />
          <select
            className={`poxinput ${styles["paddingLeft32px"]} `}
            onChange={(e) => {
              setAvgTime(avgTimeArrayState[e.target.value]);
              setAvgTimeValue(e.target.value);
              settatError("");
            }}
            value={avgtimeValue}
            name="avgtime"
          >
            <option value="">From </option>

            {avgTimeArray.map((data, index) => {
              return (
                <option key={index} value={data}>
                  {data}
                </option>
              );
            })}
          </select>
          {tatError && <div className="text-danger">{tatError}</div>}
        </div>
      </div>
      <div className="mt-3">
        <div className="">
          <span className="text-danger">*</span> Enter rate of interest to make
          loan offer
        </div>
        <div class="container ">
          <div class="row justify-content-between">
            <div
              className={`col-5 ${styles["paddingUnset"]} position-relative`}
            >
              <img
                src={roiIcon}
                className={`position-absolute ${styles["clockCSS"]} ${styles["roiTop"]}`}
              />
              <input
                name="from"
                type="number"
                // className={error && error.pan_number && error.pan_number !== "" ? "poxinput-error" : "poxinput"}
                className={`poxinput ${styles["paddingLeft32px"]}`}
                id=""
                onChange={(e) => {
                  setFrom(e.target.value);
                  setRoiFromError("");
                }}
                // onKeyPress={onKeyPressSubmit}
                value={from}
                required
                placeholder="ex - 11%"
                // readOnly={isAadhaarOrPan === ""}
              />{" "}
              {roiFromError && (
                <div className="text-danger">{roiFromError}</div>
              )}
            </div>
            <div
              className={`col-5 ${styles["paddingUnset"]} position-relative`}
            >
              <img
                src={roiIcon}
                className={`position-absolute ${styles["clockCSS"]} ${styles["roiTop"]}`}
              />
              <input
                name="to"
                type="number"
                // className={error && error.pan_number && error.pan_number !== "" ? "poxinput-error" : "poxinput"}
                className={`poxinput ${styles["paddingLeft32px"]}`}
                id=""
                onChange={(e) => {
                  setTo(e.target.value);
                  setRoiToError("");
                }}
                // onKeyPress={onKeyPressSubmit}
                value={to}
                required
                placeholder="ex - 15%"

                // readOnly={isAadhaarOrPan === ""}
              />
              {roiToError && <div className="text-danger">{roiToError}</div>}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <span className="text-danger">*</span> These values are subject to
        change as per case.
      </div>
      <div className="mt-3">
        <a
          href="javascript:void(0)"
          className="form-control posubmit"
          style={{
            backgroundColor: "#e08701",
            textAlign: "center",
            color: "#fff",
            fontWeight: "600",
            cursor: "pointer",
          }}
          onClick={() => onSubmit()}
        >
          Submit
        </a>
      </div>
    </div>
  );
};

export default LoanOfferData;
